var React = require('react');

function Chatbots (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M48.333,1.667H15A13.333,13.333,0,0,0,1.667,15V31.667A13.333,13.333,0,0,0,15,45h3.333V58.333L33.333,45h15A13.333,13.333,0,0,0,61.667,31.667V15A13.333,13.333,0,0,0,48.333,1.667Z","fill":"none","stroke":"#da1884","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"3.333","key":0}),React.createElement("path",{"d":"M38.333,55v5a8.333,8.333,0,0,0,8.333,8.333H55l10,10v-10h5A8.333,8.333,0,0,0,78.333,60V50A8.333,8.333,0,0,0,70,41.667H68.333","fill":"none","stroke":"#da1884","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"3.333","key":1})]);
}

Chatbots.defaultProps = {"width":"80","height":"80","viewBox":"0 0 80 80"};

module.exports = Chatbots;

Chatbots.default = Chatbots;
